import '../../../../../../../../node_modules/@dicetechnology/doris-ui/src/scss/main.scss';
import '../../scss/doris-video-player.scss';
import React, {
    Fragment, useEffect, useRef, useState
} from 'react';
import { Player, buildConfig } from '@dicetechnology/doris-core';
import { addNativeHandler } from '@dicetechnology/doris-handler-native';
import { addHlsHandler } from '@dicetechnology/doris-handler-hls';
import { getVideoMetadataAsync } from '../../../../general/js/api/endeavor/services/vod-service';
import VideoPlayerWrapper from './video-player-wrapper';
import { GRANTED_ON_SIGN_IN } from '../../../../general/js/api/endeavor/constants/api-constants';
import { useUniqueId } from '../../../../general/js/hooks/useUniqueId';

const EndeavorPlayer = ({
    content,
    stopPlayer,
    propsMetadata = { isEmpty: true },
}) => {
    const [player, setPlayer] = useState(null);
    const playerRef = useRef(null);
    const uniqueId = useUniqueId();

    const [endeavorMetadata, setEndeavorMetadata] = useState({ isEmpty: true });
    const { videoId } = content;

    const playerKey = `dorisPlayer-${content.videoId}-${uniqueId}`;

    useEffect(() => {
        if (player === null && videoId && playerRef.current) {
            const newPlayer = new Player(playerKey, buildConfig(
                addHlsHandler(),
                addNativeHandler(),
            ));
            setPlayer(newPlayer);
        }
    }, [videoId]);

    useEffect(() => {
        if (stopPlayer && player !== null) {
            try {
                player.pause();
            } catch (exception) {
                //catch the player exception -> do nothing
            }
        }
    }, [stopPlayer]);

    useEffect(() => {
        if (player !== null) {
            if (propsMetadata.accessLevel === GRANTED_ON_SIGN_IN) {
                setEndeavorMetadata({ ...propsMetadata });
            } else {
                getVideoMetadataAsync({ videoId })
                    .then((response) => {
                        setEndeavorMetadata(response.metadata);
                        if (!response.metadata.hlsUrl ||
                            endeavorMetadata.accessLevel === GRANTED_ON_SIGN_IN) {
                            return;
                        }

                        player.load(response.metadata.hlsUrl).then(() => {
                            if (!content.autoplay && player !== null) {
                                player.pause();
                            }
                        });
                    });
            }
        }

        return () => {
            if (player !== null) {
                player.destroy();
            }
        };
    }, [videoId, player]);


    return (
        <Fragment>
            <VideoPlayerWrapper
                player={player}
                endeavorMetadata= {endeavorMetadata}
                content={content}
                hideCover={content.hideCover}
                playerKey={playerKey}
                playerRef={playerRef}
            />
        </Fragment>

    );
};

export default EndeavorPlayer;
